import React, { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllCommentsOfPostAPI } from '../../RTK/Slice/PageSlice';
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { useParams } from 'react-router-dom';
import ListComments from '../Utils/ListComments';

const GroupPostComments = () => {

    // For Dispatch Action
    const dispatch = useDispatch() ; 

    // For Get Token
    const token = useSelector(getToken) ; 

    // For Get Active Token
    const activeToken = useSelector(getActiveToken) ; 

    // For Access Post Id 
    const {postId} = useParams() ; 

    // For Get All Comments From API
    useEffect(()=>{
        dispatch(getAllCommentsOfPostAPI({token , userToken: activeToken  , postId}))
    } , [ dispatch , activeToken , postId , token]) ;

    // For Acccess Comments
    const {pageComments , statusOfComments} = useSelector(state => state.PageSlice) ; 

  return (
    <Fragment>
        <ListComments comments={pageComments} statusOfComments={statusOfComments} />
    </Fragment>
  )
}

export default GroupPostComments
